import React from 'react';
import {Text} from '@tenancy.nz/design-system';

function ContactContent() {
  return (
    <Text as="div">
      <p>
        If you are having problems with our site please let us know and we will
        help where we can. We cannot help with changes to tenancy applications,
        updates or general enquires about specific properties for rent.
      </p>
      <p>
        For information and updates on your tenancy applications, please contact
        the Property Manager directly.
      </p>
    </Text>
  );
}

export default ContactContent;
